module.exports = {
	"id": "IE",
	"name": "Ireland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.017343,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.046248,
			"23": null,
			"24": null,
			"25": 0.005781,
			"26": 0.005781,
			"27": null,
			"28": null,
			"29": 0.190773,
			"30": null,
			"31": 0.011562,
			"32": 0.028905,
			"33": 0.075153,
			"34": 0.028905,
			"35": 0.034686,
			"36": 0.05781,
			"37": 0.104058,
			"38": 0.052029,
			"39": 0.132963,
			"40": 0.034686,
			"41": 0.040467,
			"42": 0.069372,
			"43": 0.364203,
			"44": 0.069372,
			"45": 0.144525,
			"46": 0.046248,
			"47": 0.05781,
			"48": 0.497166,
			"49": 1.641804,
			"50": 0.607005,
			"51": 3.208455,
			"52": 0.687939,
			"53": 20.187252,
			"54": 4.457151,
			"55": 0.046248,
			"56": 0.017343,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.069372,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.028905,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.023124,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.005781,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005781,
			"29": null,
			"30": null,
			"31": 0.005781,
			"32": null,
			"33": 0.011562,
			"34": null,
			"35": 0.011562,
			"36": 0.005781,
			"37": 0.011562,
			"38": 0.121401,
			"39": 0.023124,
			"40": 0.011562,
			"41": 0.017343,
			"42": 0.017343,
			"43": 0.271707,
			"44": 0.138744,
			"45": 0.300612,
			"46": 0.439356,
			"47": 1.277601,
			"48": 0.5781,
			"49": 4.532304,
			"50": 0.034686,
			"51": null,
			"52": null,
			"3.5": 0.017343,
			"3.6": 0.011562
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.011562,
			"28": 0.023124,
			"29": 0.011562,
			"30": 0.017343,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.023124,
			"37": 0.011562,
			"38": 0.543414,
			"39": 0.023124,
			"40": 0.213897,
			"41": 0.034686,
			"42": null,
			"43": null,
			"9.5-9.6": 0.011562,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.005781,
			"12.1": 0.023124
		},
		"safari": {
			"0": null,
			"4": 0.104058,
			"5": 0.040467,
			"6": 0.005781,
			"7": 0.034686,
			"8": 0.161868,
			"9": 0.184992,
			"10": 1.127295,
			"3.1": null,
			"3.2": null,
			"5.1": 0.092496,
			"6.1": 0.063591,
			"7.1": 0.011562,
			"9.1": 0.936522
		},
		"ios_saf": {
			"8": 0,
			"10": 11.2448699084,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.303036232306,
			"8.1-8.4": 0.559846598668,
			"9.0-9.2": 0.267082781016,
			"9.3": 4.0747244796
		},
		"android": {
			"3": 0,
			"4": 0.0236625322997,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00295781653747,
			"4.1": 0.0853541343669,
			"4.2-4.3": 0.213385335917,
			"4.4": 0.489307364341,
			"4.4.3-4.4.4": 0.493532816537
		},
		"ie": {
			"6": 0.0946856176991,
			"7": 0.0946856176991,
			"8": 1.56907595044,
			"9": 0.642509548673,
			"10": 0.7642482,
			"11": 4.47727706549,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0107678274268,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000299106317411
		},
		"edge": {
			"12": 0.248583,
			"13": 0.682158,
			"14": 1.364316
		},
		"ie_mob": {
			"10": 0.146451830986,
			"11": 0.596268169014
		},
		"bb": {
			"7": 0.005275,
			"10": null
		},
		"samsung": {
			"0": 3.35068
		},
		"and_uc": {
			"0": 0.05064
		},
		"op_mini": {
			"0": 0.145073066256
		},
		"and_chr": {
			"0": 20.923778
		},
		"and_ff": {
			"0": 0.02954
		}
	},
	"total": 97.612297
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IE.json
 ** module id = 548
 ** module chunks = 0
 **/